import { render, staticRenderFns } from "./Themes.vue?vue&type=template&id=5c8fec96&%3ApageData=pageData&"
import script from "./Themes.vue?vue&type=script&lang=js&"
export * from "./Themes.vue?vue&type=script&lang=js&"
import style0 from "../assets/style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports